// Types for the bulk grant transaction upload flow

export interface TransactionUploadRow {
  grantId: string;
  transactionDate: Date | string;
  noOfOptions: number;
  transactionType: string;
  fmv?: number;
  buyerName?: string;
  rowNumber?: number;
}

export interface ParsedTransactionRow extends TransactionUploadRow {
  id?: string;
  grantDbId?: string;
  isFractional?: boolean;
  employeeName?: string;
  currentVested?: number;
  currentExercised?: number;
  currentActive?: number;
  isValid: boolean;
  errors: string[];
}

export interface TransactionValidationResult {
  valid: boolean;
  data: ParsedTransactionRow[];
  errors: string[];
}

// Valid transaction types for bulk upload
export const VALID_TRANSACTION_TYPES = [
  "LAPSED",
  "CASHED_OUT",
  "STOCK_EXERCISE",
  "SOLD",
  "SURRENDERED",
] as const;

export type TransactionType = typeof VALID_TRANSACTION_TYPES[number];

export interface UpdateTransactionsResponse {
  created: number;
  errors?: string[];
  data?: ParsedTransactionRow[];
}
